import { Component, OnInit, ChangeDetectorRef, HostListener, ElementRef, ViewChild,Input
,Output,EventEmitter } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AppService } from '../../../../../services/app.service';
//import moment = require('moment');
import * as  moment from 'moment';
import * as _ from 'lodash';
import { StateService } from '../../../../../services/state.service';
import { UtilitaryService } from '../../../../../services/utilitary.service';
import { FormDialogFormulaireComponent } from '../../../../../motor-form-atyl/form-atyl-components/form-dialog/form-dialog-formulaire.component';
import { FormulaireDossierDialogComponent } from '../../../../partials/layout/dialog/formulaire-dossier-dialog.component';
import { UploadFileDialogComponent } from '../../../../partials/../partials/layout/dialog/upload-file-dialog.component';
import { CourrierDialog } from '../../../../partials/layout/dialog/courrier-dialog.component';
import { of, Subject,Observable } from 'rxjs';
import { FormDialogFormulaireWithSFComponent } from '../../../../../motor-form-atyl/form-atyl-components/form-dialog/form-dialog-formulaire-with-sf.component';
import { ConfirmComponent } from '../../../../partials/layout/dialog/confirm.component';
import { debounceTime, first, ignoreElements } from 'rxjs/operators';
import { DroitsService } from '../../../../../services/droits.service';
import { ChoiceCourrierComponent } from '../../../../partials/layout/dialog/choice-courrier.component';
import { EtapeinstructionComponent } from '../../../../partials/layout/dialog/etapeinstruction.component';
import { FormulaireDossierRDVDialogComponent } from '../../../../partials/layout/dialog/formulaire-dossier-rdv-dialog.component';
import { TransmettreDialogComponent } from '../../../../partials/layout/dialog/transmettre-dialog.component';
import {DialogService} from '../../../../../services/dialog-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { InstructionHistoriqueDialog } from '../../../../partials/layout/dialog/instruction-historique-dialog/instruction-historique-dialog.component'

import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'

const KEY = 'one-instruction'

@Component({
  selector: 'atyl-instruction-list',
  templateUrl: './instruction-list.component.html',
  styleUrls: ['./instruction-list.component.scss']
})

@Stringable({
	path: 'views/partials/content/instruction/instruction',
	key: KEY,
})

export class InstructionListComponent implements OnInit {

	@StringableValues(KEY) strings: any	
	
@Input() typeInstruction: string = "";
@Input() eventLoad: Observable<boolean>;

@Input() dossier:any;
@Input() tiers:any;
@Input() user: any;
@Input() eventInstructionOpen:any;
@Input() tierAccess: any;
@Input() userDroits: any;
@Input() historique: any;
@Input() filterInstruction:number[]=[];

@Output() change = new EventEmitter<any>();
@Output() refresh = new EventEmitter();
@Output() loadTabs = new EventEmitter();

@Input() viewDelete: Observable<boolean>
isViewDelete:boolean=false;

currentTab: any;
donnees:any;
donneesEquip:any;
donneesSynth:any;
etat:any;
selectedInstruc:any = [];
selectedInstrucFormation:any;
selectedInstrucEnfant:any;
lastAgrement:any;
cachedAgre: any;
currentInstru: any;
lastFormation:any;
cachedInstruc:any;
droits:any=[];
cachedInstrucHisto:any;

signataire: any = "";
nom:string = "";
reference:string = "";
AgreeDuAuDate:string;
AgreeJusquAuDate:string;

selectedTab:number = 0;


listAgrement:any = [];

listContact:any = [];
allDocumentsDossier: any[] = [];
typeFormsRDV:any[] = [];
typeSuivis:any[] = [];
listInstructions:any[] = [];

updSigna:boolean = true;
updInstruc:boolean = false;
loadingInstructionList:boolean = false;
isLoadInstruction:boolean = false;
isLoadDossier:boolean = true;
loadingAgrement:boolean = false;
updDossier:boolean = true;
hasSynth: boolean = false;
loading:boolean = true;

userRigths: any = [];

userRigthsElement: any = [];
loadingSyntheseType:boolean = true;

listSubscribe: any[] = [];
appSubscribe: any;

unlock:boolean = false;

communication:boolean = false;
commSubscribe: any;

@ViewChild('tabGroup', {static: false}) tabGroup;
private debounce: Subject<string> = new Subject();

    constructor(
        private dialogService: DialogService,
        private activatedRoute: ActivatedRoute,
        private appService: AppService,
        private stateService: StateService,
        private changeDetectorRef: ChangeDetectorRef,
        public dialog: MatDialog,
        private utilities: UtilitaryService,
        private datePipe: DatePipe,
        private router: Router,
        public droitsService: DroitsService,
		private snackbar: MatSnackBar,
    
      ) { 
        
      }
     
    ngOnInit() {
       if (this.user!=undefined
          && this.user.rights!=undefined)
           this.userRigthsElement=this.user.rights;
        
        if (this.user!=undefined
          && this.user.rights!=undefined
         && this.user.rights["instruction"]!=undefined )
		      this.userRigths=this.user.rights["instruction"];	  
         console.log("DossierPageSuivisComponent init",this.dossier,this.userRigths,this.userRigthsElement)
        
        this.unlock= (this.user!=undefined 
			&& this.user.droits!=undefined
			&& this.user.droits.FORM_DEVEROUILLER!=undefined);
			        
        this.appSubscribe=this.eventLoad.subscribe((loading:boolean) => {
           console.log("InstructionListComponent eventLoad",loading)
			 if(loading){
             this.isLoadInstruction = false;
             this.tabInstructionLoad();
             this.changeDetectorRef.detectChanges();
			}	 else {
			this.listSubscribe.forEach((sub) => {
			       sub.unsubscribe();
			 })
			}
        });
		
		 this.commSubscribe=this.stateService.communication.subscribe((comm) => {
			if(!comm.error && comm.type!=undefined){
			      this.communication = Object.keys(comm.type).length > 0;
			 }
		});
		
		this.viewDelete.subscribe((view:boolean) => {
			      this.isViewDelete=view;
				  console.log("InstructionListComponent",view,this.isViewDelete);
		            this.changeDetectorRef.detectChanges();
		        
		 });
       
       /*
        this.activatedRoute.params.subscribe(routeParams => {
            this.dossier.ID = routeParams.id;
              this.listSubscribe.push(this.stateService.dossier.subscribe((dossier) => {
                  if(dossier && Object.keys(dossier).length > 0){
                  this.generateDataFromDossier(dossier);
                  }
              }));
              this.appService.getTypeSuivis().subscribe((result) => {
                this.typeSuivis = result.result;
              });
            this.listSubscribe.push(this.stateService.refresh.subscribe((res) => {
              this.selectedTab = res;
              this.isLoadInstruction = false;
           //   this.tabInstructionLoad();
              this.changeDetectorRef.detectChanges();
            }));
           
            this.stateService.user.subscribe((user) => {
              if(user.droits === Object(user.droits))
                this.userDroits = [user.droits];
              else
                this.userDroits = user.droits;
              this.user = user;
            });
        });
        */
    }
	
	ngOnDestroy() {
		    // this.stateService.updateDossier("");
		     this.listSubscribe.forEach((sub) => {
		       sub.unsubscribe();
		     })
		 if (this.appSubscribe!=undefined)
			 this.appSubscribe.unsubscribe();
		 if (this.commSubscribe!=undefined)
		 	this.commSubscribe.unsubscribe();
	 }
		  
    getChoiceCourrier(instruction: any): void{
        let droitcourier:any[]=[];
		if (this.droits.droits!=undefined 
		&& this.droits.droits.courrier!=undefined
		/*&& this.droits.droits.form.length>0*/
		 )
		 droitcourier=this.droits.droits.courrier
		 
		   let rightsCourrier:any[]=[];
       	if (this.userRigthsElement["courrier"]!=undefined)
       		rightsCourrier=this.userRigthsElement["courrier"];
		 
        console.log("getChoiceCourrier before",instruction);   
        const dialogRef = this.dialogService.open(ChoiceCourrierComponent,{
          data: {
            instruction : instruction,
            demande: instruction.demande,
            droits: droitcourier,
            rights:rightsCourrier
          },
		   width:"40%"
        });
        dialogRef.afterClosed().subscribe((result) => {
			console.log("getChoiceCourrier before result",result);   
          if(result){
               this.isLoadDossier=false;
               this.isLoadInstruction=false;	  
                   this.tabInstructionLoad();
               console.log("getChoiceCourrier result",result.length,result); 
               
               if (result.length==1) {
				   let cr:any=result[0];
                   this.getCourrier(this.selectedInstruc,cr)  
                }
          }
        });
      }

    canShowButton(instru:any) {
        let instructionTypeID=instru.type.ID;
        if(this.tierAccess && this.tiers && this.tiers.type !== "CCPD" && instru.transmission)
          return !this.tierAccess.includes(instructionTypeID);
        else
          return false;
      }

    displayAutoSelectListInstru(key?: any): string | undefined {
        let selected;
        if(this.selectedInstruc && this.selectedInstruc.possibleTiers){
          this.selectedInstruc.possibleTiers.forEach((select) => {
            if(key && select.ID === key.ID)
              selected = select;
          })
        }
        return selected ? selected.NOM + ' ' + (selected.PRENOM ? selected.PRENOM : ''): undefined;
      }
    
    signCourrier(demandecourrier: any) {
        const confDialogRef = this.dialogService.open(ConfirmComponent, {
            data : {
            libelle : 'Etes-vous sur de vouloir signer ce courrier ?'
            }
        });
        confDialogRef.afterClosed().subscribe(res => {
            if(res && res === 'true'){
                this.appService.signCourrier(demandecourrier.ID).subscribe((res) => {
                    this.isLoadInstruction=false;
                    this.tabInstructionLoad();
                });
            }
        });
    }

    unsignCourrier(demandecourrier: any) {
     
        const confDialogRef = this.dialogService.open(ConfirmComponent, {
          data : {
            libelle : 'Etes-vous sur de vouloir enlever la signature de ce courrier ?'
          }
        });
        confDialogRef.afterClosed().subscribe(res => {
          if(res && res === 'true'){
            this.appService.unsignCourrier(demandecourrier.ID).subscribe((res) => {
              this.isLoadInstruction=false;
                  this.tabInstructionLoad();
            });
          }
        });
    }

    deleteCourrier(demandeCour: any){
        if(this.updDossier && demandeCour && !demandeCour.verrouille){
          const confDialogRef = this.dialogService.open(ConfirmComponent, {
            data : {
              libelle : 'Etes-vous sur de vouloir supprimer ce courrier ?'
            }
          });
          confDialogRef.afterClosed().subscribe(res => {
            if(res && res === 'true'){
              this.appService.setCourrierDelete(demandeCour.ID).subscribe((forms) => {
                this.isLoadInstruction=false;
                this.tabInstructionLoad();
              })
            }
          });
        }
       }
	 
	restoreCourrier(demandeCour: any){
	           if(this.updDossier && demandeCour && !demandeCour.verrouille){
	             const confDialogRef = this.dialogService.open(ConfirmComponent, {
	               data : {
	                 libelle : 'Etes-vous sur de vouloir restaurer ce courrier ?'
	               }
	             });
	             confDialogRef.afterClosed().subscribe(res => {
	               if(res && res === 'true'){
	                 this.appService.setCourrierRestore(demandeCour.ID).subscribe((forms) => {
	                   this.isLoadInstruction=false;
	                   this.tabInstructionLoad();
	                 })
	               }
	             });
	           }
	 }  
	     
	  
	   

    getCourrier(instruction: any, courrier ?: any, editable = true): void {
      if (courrier.courrier.signature === 3 && courrier.signataire_date) {
        window.open(courrier.value.url, ' _blank');
      } else {
        console.log("DossierPageInstructionsComponent getCourrier",instruction,courrier,editable)
        this.currentInstru = this.selectedInstruc;
        const dialogRef = this.dialogService.open(CourrierDialog, {
          data: {
            instruction: instruction,
            courriers: instruction.courriers,
            demande : instruction.demande,
            courrier : courrier,
            isEditable: editable && this.updDossier && (courrier.all_rights || courrier.readAndWrite ? true : false) ,
            signature : this.currentInstru.type.signature && this.signataire ? true : false,
            droits: this.droits
          },
          panelClass:['container-courrier'],
          width:"70vw"
        });

        dialogRef.afterClosed().subscribe(result => {
          if(result){
            this.isLoadInstruction=false;
            this.tabInstructionLoad();
          }
        });
      }
    }

    downloadCourrier(instruction:any, courrier:any){
		
		let typeCourier:string=(courrier.value!=undefined && courrier.value.mime!=undefined
					&& courrier.value.mime!="application/pdf" )? "HTML2DOCX": "HTML2PDF";
					console.log("downloadCourrier",courrier,typeCourier);
			this.appService.getCourrierOne(courrier, instruction.demande, typeCourier, (courrier && courrier.ID ? courrier.ID : ''), courrier.libres, this.dossier.ID).then((courrierReceive) => {         
          
				if (courrierReceive.result!=undefined && courrierReceive.result
					&& courrierReceive.result.value!=undefined 
					&& courrierReceive.result.value.url!=undefined 
					
				 )
				 window.open(courrierReceive.result.value.url, '_blank');
				 else
				 	of(window.confirm("Le type de courrier demandé n'est pas présent, problème de configuration"));
		/*if(courrierReceive.result && courrierReceive.result.length > 0){
            courrierReceive.result.forEach((cour) => {
                  if(cour.ID === courrier.ID){
                      if(cour.value){
                          window.open(cour.value.url, '_blank');
                      }
                      else
                          of(window.confirm("Le type de courrier demandé n'est pas présent, problème de configuration"));
                  }
              });
          }*/
        });
    }
	
	openCourrier(instruction:any, courrier:any) {
		
		if (courrier!=undefined && courrier.value!=undefined && courrier.value.url!=undefined )
			window.open(courrier.value.url, '_blank');
	}

    NewRDVDialog(form:any,instru:any){
        console.log("form:",form,"instru:",instru,"rdv");
          let rightsForm:any[]=[];
       	if (this.userRigthsElement["formulaire"]!=undefined)
       		rightsForm=this.userRigthsElement["formulaire"];
        const dialogRef = this.dialogService.open(FormulaireDossierRDVDialogComponent,{
          data: {
            instruction : instru,
            typeForm: 1,
            droits: this.droits,
            rights: rightsForm
          },
		  width:"40%"
        });
        dialogRef.afterClosed().subscribe((result) => {
          if(result){
            console.log(result,"result");
            if (result.selectedForm!=undefined) {
           // this.appService.getForm(result.selectedForm.key, this.dossier.ID).subscribe((res) => {
              const dialogRefRDV = this.dialog.open(FormDialogFormulaireComponent,{
                data: {
                  typeFormulaire: result.selectedForm.key,
                  dossierId: this.dossier.ID,
                  dossier:this.dossier,
                  title: result.selectedForm.libelle,
                  form: '',
                  instruction: instru
                },
                height:"90vh",
                width:"80vw"
              });
          
              dialogRefRDV.afterClosed().subscribe(result => {
                if(result){
                  console.log(this.selectedInstruc);
                  this.isLoadInstruction=false;
                    this.tabInstructionLoad();
                }
              });
           // });
          }
          }
        });
    }

    countCourAfterDroits(courriers){
    
        let count = 0;
        courriers.forEach((cour) => {
          if(cour.ID)
            count++;
        })
        return count;
      }

    getDateFromRDV(form:any){
        let RDV = "";
        if(form.form && form.form.fields && form.form.fields.length > 0){
          form.form.fields.forEach((field) => {
			//console.log("InstructionListComponent getDateFromRDV",field);
            if(field.field && field.field.type=="date" && (field.field.key.includes( "RENDEZVOUS_DATE") || field.field.key === "RENDEZVOUS_DATE" || field.field.key === "DATEWITHTIME")){
				//console.log("InstructionListComponent getDateFromRDV value",field.value);
				let UTCtransform = this.datePipe.transform(field.value, 'H:mm', "+0000");
              if(UTCtransform !== "0:00")
                RDV = this.datePipe.transform(field.value, 'dd/MM/yyyy à H:mm', "+0000");
              else
                RDV = this.datePipe.transform(field.value, 'dd/MM/yyyy',"+0000");
			  console.log("InstructionListComponent getDateFromRDV value",field.value, RDV);	
            }
          });
        }
        return RDV;
      }

    countRDVAfterDroits(forms){
        let count = 0;
        forms.forEach((form) => {
            count++;
        })
        return count;
    }

    addDocument(documents: any){
        this.currentInstru = this.selectedInstruc;
        
         let droitdoc:any[]=[];
		if (this.droits.droits!=undefined 
		&& this.droits.droits.document!=undefined
		/*&& this.droits.droits.form.length>0*/
		 )
		 droitdoc=this.droits.droits.document
       let rightsDoc:any[]=[];
       	if (this.userRigthsElement["document"]!=undefined)
       		rightsDoc=this.userRigthsElement["document"];
       		
        const dialogRef = this.dialogService.open(UploadFileDialogComponent,{
          data: {
            instruction: this.currentInstru,
            documents: documents,
            droits: droitdoc,
            rights: rightsDoc
          },
          width:"32vw"
        });
        dialogRef.afterClosed().subscribe(result => {
          if(result != ""){
            result.selectedDocument.status = result.currentEtat;  
            result.selectedDocument.value.parameter = result.selectedDocument.parameter;
            result.selectedDocument.value.description = result.selectedDocument.description ? result.selectedDocument.description.replace(/<[^>]*>/g, '') : '';
            result.selectedDocument.value.archive = JSON.parse(result.archive);
            this.appService.setDocumentByInstruction(this.currentInstru.demande.ID, result.selectedDocument).subscribe((res) => {
                this.isLoadInstruction=false;
                  this.tabInstructionLoad();
            });
          }
        });
    }

    deleteDocument(demandeDoc: any){
        if(this.updDossier && demandeDoc && !demandeDoc.verrouille){
          const confDialogRef = this.dialogService.open(ConfirmComponent, {
            data : {
              libelle : 'Etes-vous sur de vouloir supprimer ce document ?'
            }
          });
          confDialogRef.afterClosed().subscribe(res => {
            if(res && res === 'true'){
              this.appService.setDocumentDelete(demandeDoc.ID).subscribe((forms) => {
                this.isLoadInstruction=false;
                this.tabInstructionLoad();
              })
            }
          });
        }
    }

    restoreDocument(demandeDoc: any) {
        if(this.updDossier && demandeDoc && !demandeDoc.verrouille){
          const confDialogRef = this.dialogService.open(ConfirmComponent, {
            data : {
              libelle : 'Etes-vous sur de vouloir restaurer ce document ?'
            }
          });
          confDialogRef.afterClosed().subscribe(res => {
            if(res && res === 'true'){
              this.appService.setDocumentRestore(demandeDoc.ID).subscribe((forms) => {
                this.isLoadInstruction=false;
                this.tabInstructionLoad();
              });
            }
          });
        }
    }

    countFormsAfterDroits(forms){
        let count = 0;
        forms.forEach((form) => {
            count++;
        })
        return count;
      }

    getLabelTransmission(){
        if(this.tiers.type === "ASSMAT")
          return "Transmettre AMAT";
        else if(this.tiers.type === "ASSFAM")
          return "Transmettre ASSFAM";   
        else if(this.tiers.type === "EAJE")
          return "Transmettre EAJE";
        else if(this.tiers.type === "MAM")
          return "Transmettre MAM";
        else if(this.tiers.type === "RAM")
          return "Transmettre RAM";
        else if(this.tiers.type === "CCPD")
          return "Transmettre CCPD";
      }

      countIncompFormsAfterDroits(forms){
        let count = 0;
        forms.forEach((form) => {
          if(form.status === 1){
            count++;
          }
        })
        return count;
      }

    uploadeDialog(document:any, editable = true){
        this.currentInstru = this.selectedInstruc;
         console.log("DossierPageInstructionsComponent uploadeDialog before",document)  
        const dialogRef = this.dialogService.open(UploadFileDialogComponent,{
          data: {
            instruction: this.currentInstru,
            document: document,
            documents: this.allDocumentsDossier,
            isEditable: editable && this.updDossier && (document.all_rights || document.readAndWrite ? true : false),
            droits: this.droits
          },
          width:"30vw"
        });
        dialogRef.afterClosed().subscribe(result => {
          if(result && result != ""){
			  
			
            document.value = result.selectedDocument.value;
            document.value.parameter = result.selectedDocument.parameter;
            document.value.description = result.selectedDocument.description.replace(/<[^>]*>/g, '');;
            document.value.archive = JSON.parse(result.archive);
            document.status = result.currentEtat;
            
            console.log("DossierPageInstructionsComponent uploadeDialog afterClosed" ,result,document)  
            
            this.appService.setDocumentByInstruction(document.demandeid ? document.demandeid : this.currentInstru.demande.ID, document).subscribe((res) => {
              this.isLoadInstruction=false;
                this.tabInstructionLoad();
            });
          }
        });
    }

    download(urlSuivi: string) {
        window.open(urlSuivi,' _blank');
    }

    clearSelectInstruction() {
        return {
           "documents":[]
        };
     
    }

    countDocsAfterDroits(documents){
        let count = 0;
        documents.forEach((doc) => {
          if(doc.ID)
            count++;
        });
        return count;
    }

    addForm(instru: any) {
       let droitform:any[]=[];
		if (this.droits.droits!=undefined 
		&& this.droits.droits.form!=undefined
		/*&& this.droits.droits.form.length>0*/
		 )
		 droitform=this.droits.droits.form
       
       let rightsForm:any[]=[];
       if (this.userRigthsElement["formulaire"]!=undefined)
       		rightsForm=this.userRigthsElement["formulaire"];
       
        const dialogRef = this.dialogService.open(FormulaireDossierDialogComponent,{
          data: {
            instruction : instru,
            droits: droitform,
            rights: rightsForm
          },
		  width:"40%"
        });
        dialogRef.afterClosed().subscribe((result) => {
          if(result){
            let arrayId = [];
            result.forEach((form) => {
                if(form.selected)
                    arrayId.push(form.key);
            });
            this.appService.setFormulaires(arrayId, instru).subscribe((res) => {
                this.isLoadDossier=false;
                this.isLoadInstruction=false;	  
                this.tabInstructionLoad();
              //  formulaireDialog
                console.log("DossierPageInstructionsComponent addForm",res.result.length,res);
                
                if (res.result!=undefined && res.result.length==1 ) {
					let dem_form:any=res.result[0];
                	this.formulaireDialog(dem_form.form.key,dem_form.form.libelle, dem_form.form, dem_form);
                }	
            })
          }
            this.reloadDossier();
            this.changeDetectorRef.detectChanges();
        });
    }

    // ! Useless definition
    // getTypeSynthese()
    // {
    //     this.appService.getValueSynthese(this.loadingSyntheseType).subscribe(res =>{
    //         if(!res || res.result === false)
    //         {
    //             this.loadingSyntheseType = false;
    //         }
    //         else{
    //             this.loadingSyntheseType = true;
    //         }
    //    });
    // }

    restoreFormulaire(demandeForm: any) {
        if(this.updDossier && demandeForm && !demandeForm.verrouille){
          const confDialogRef = this.dialogService.open(ConfirmComponent, {
            data : {
              libelle : 'Etes-vous sur de vouloir restaurer ce formulaire ?'
            }
          });
          confDialogRef.afterClosed().subscribe(res => {
            if(res && res === 'true'){
              this.appService.setFormulaireRestore(demandeForm.ID).subscribe((forms) => {
				let droitform:any[]=[];
		        if (this.droits.droits!=undefined 
		        && this.droits.droits.form!=undefined)
		            droitform=this.droits.droits.form
				let _opts:any={notValueType:[0,2,3,4,5,6,7],noType:[6,7]}	
                this.appService.getFormulairesForDemande(this.currentInstru.demande.ID,false,_opts).subscribe((forms) => {
                  let tempForms = [];
                  let rdvForms = [];
                  forms.result.forEach((form) => {
					let added:boolean=true;
	                form.editable=true;
	                console.log("DossierPageInstructionsComponent changeInstructionEnfant",form,this.userRigthsElement) 

	                if (
	                    form.form   !=undefined
	                    &&  form.form.key !=undefined 
	                    && form.form.key
	                    && droitform[form.form.key]!=undefined
	                    && droitform[form.form.key].r!=undefined	
	                ) {
				        //	console.log("formulaireService dorit r",droitform[f.form.key],f)
	                    if (!droitform[form.form.key].r)
	                        added=false;
	                }
	                
	                if (
	                    form.form   !=undefined
	                    &&  form.form.key !=undefined 
	                    && form.form.key
	                    && droitform[form.form.key]!=undefined
	                    && droitform[form.form.key].w!=undefined	
	                ) {
	                    form.editable=droitform[form.form.key].w;
	                } 
	                
	                let rg:any={
						r:true,
						w:true
					};
	                if ( form.form   !=undefined
	                    &&  form.form.key !=undefined 
	                    && form.form.key
						&& this.userRigthsElement["formulaire"]!=undefined
	                && this.userRigthsElement["formulaire"][form.form.key]!=undefined
	                )
	                rg=this.userRigthsElement["formulaire"][form.form.key];
	                form.right=rg;
					
					if(form.form && (form.form.type === 0 || form.form.type === 3 ||form.form.type === 5))
                      tempForms.push(form);
                    else if(form.form && form.form.type === 1)
                      rdvForms.push(form);
                  });
                  this.currentInstru.selectedForms = tempForms;
                  this.currentInstru.selectedRDV = rdvForms;
            
                  this.changeDetectorRef.detectChanges();
                });
              })
            }
          });
        }
    }

    deleteFormulaire(demandeForm: any){
      if(this.updDossier && !demandeForm.verrouille){
        const confDialogRef = this.dialogService.open(ConfirmComponent, {
          data : {
            libelle : 'Etes-vous sur de vouloir supprimer ce formulaire ?'
          }
        });
        confDialogRef.afterClosed().subscribe(res => {
          if(res && res === 'true'){
            this.appService.setFormulaireDelete(demandeForm.ID).subscribe((forms) => {
              this.currentInstru = this.selectedInstruc;
      let droitform:any[]=[];
          if (this.droits.droits!=undefined 
          && this.droits.droits.form!=undefined)
              droitform=this.droits.droits.form
			let _opts:any={notValueType:[0,2,3,4,5,6,7],noType:[6,7]}
              this.appService.getFormulairesForDemande(this.currentInstru.demande.ID,false,_opts).subscribe((forms) => {
                let tempForms = [];
                let rdvForms = [];
                forms.result.forEach((form) => {
        
        let added:boolean=true;
                form.editable=true;
                console.log("DossierPageInstructionsComponent changeInstructionEnfant",form,this.userRigthsElement) 

                if (
                    form.form   !=undefined
                    &&  form.form.key !=undefined 
                    && form.form.key
                    && droitform[form.form.key]!=undefined
                    && droitform[form.form.key].r!=undefined	
                ) {
              //	console.log("formulaireService dorit r",droitform[f.form.key],f)
                    if (!droitform[form.form.key].r)
                        added=false;
                }
                
                if (
                    form.form   !=undefined
                    &&  form.form.key !=undefined 
                    && form.form.key
                    && droitform[form.form.key]!=undefined
                    && droitform[form.form.key].w!=undefined	
                ) {
                    form.editable=droitform[form.form.key].w;
                } 
                
                let rg:any={
          r:true,
          w:true
        };
                if ( form.form   !=undefined
                    &&  form.form.key !=undefined 
                    && form.form.key
          && this.userRigthsElement["formulaire"]!=undefined
                && this.userRigthsElement["formulaire"][form.form.key]!=undefined
                )
                rg=this.userRigthsElement["formulaire"][form.form.key];
                form.right=rg;
        
                  if(form.form && (form.form.type === 0 || form.form.type === 3 ||form.form.type === 5))
                    tempForms.push(form);
                  else if(form.form && form.form.type === 1)
                    rdvForms.push(form);
                });
                  this.currentInstru.selectedForms = tempForms;
                  this.currentInstru.selectedRDV = rdvForms;
                  
                  this.changeDetectorRef.detectChanges();
              });
            })
              //this.reloadDossier();
          }
        });
      }
  }

    unlockForm(form: any){
        if(this.updDossier || this.unlock){
         const confDialogRef = this.dialogService.open(ConfirmComponent, {
          data : {
            libelle : 'Etes-vous sur de vouloir déverrouiller ce formulaire ?'
          }
         });
         confDialogRef.afterClosed().subscribe(res => {
           if(res === 'true'){
             this.appService.unlockFormulaire(form.ID).subscribe((res) => {
				if (res.result!=undefined) {
		               this.isLoadInstruction=false;
		               this.tabInstructionLoad();
				 }
				 if (res.error!=undefined) { 
					let message:string=(res.error.data!=undefined) ? res.error.data : res.error.message;
					  let snackBarRef = this.snackbar.open(message,'', {
				                duration: 30000
								              });
					
				}
				  
             });
           }
         });
   
        }
    }

    lockForm(form: any){
        if(this.updDossier || this.unlock){
         const confDialogRef = this.dialogService.open(ConfirmComponent, {
          data : {
            libelle : 'Etes-vous sur de vouloir verrouiller ce formulaire ?'
          }
        });
        confDialogRef.afterClosed().subscribe(res => {
          if(res === 'true'){
            this.appService.lockFormulaire(form.ID).subscribe((res) => {
              this.isLoadInstruction=false;
              this.tabInstructionLoad();
            });
          }
        });
   
       }
    }

    reloadDossier(){
        if (!this.isLoadDossier) {
             this.loading=true;
        this.appService.getDossier(this.dossier.ID)
              .subscribe(dossier => {
              
              this.changeDetectorRef.detectChanges();
              this.stateService.updateDossier(dossier.result);
              this.loading=false;
              this.isLoadDossier=true;
    
    		  this.refresh.emit(dossier.result);
              this.tabInstructionLoad();
            });
        }
    }

    formulaireDialog(typeFormulaire: string, libelle: string, form ?: any, demandeForm ?: any, editable = true, typeInstru ?: any){
        
        this.currentInstru = this.selectedInstruc;
		const ishisto:boolean=( (!this.historique && this.updDossier)  || (this.historique && this.unlock));
		
        const isEditable = editable  && (form.all_rights || form.readAndWrite ? true : false) && ishisto;
		
		console.log('typeFormulaire:',typeFormulaire,'\nlibelle:',libelle,'\nform:',form,'\ndemandeForm:',demandeForm,'\neditable:',editable,
				        '\neditable2:',
				        ( editable && this.updDossier && (form.all_rights || form.readAndWrite ? true : false)),
				        this.updDossier,
				        form.all_rights,
				        form.readAndWrite,
						'ishisto:',ishisto,isEditable,this.unlock
				        );
		
        var dialogRef = null;
        if(form && form.under_form && form.under_form.length === 0){
           
         let datasF={
              typeFormulaire: typeFormulaire,
              dossierId: this.dossier.ID,
              dossier:this.dossier,
              title: libelle,
              form: form,
              instruction: this.currentInstru,
              demandeFormulaire: demandeForm,
              isEditable: isEditable,
			  isHistoric:(this.historique && this.unlock)
            }; 
           
          dialogRef = this.dialog.open(FormDialogFormulaireComponent,{
            data: datasF,
            panelClass: ['animate__animated','animate__slideInDown'],
            height:"90vh",
            width:"80vw"
          });
      

        }
        else if (form && form.under_form && form.under_form.length > 0){
            let datasF={
              title: libelle,
              id: demandeForm.ID,
              dossier:this.dossier,
              formType: demandeForm.key,
              instruction: this.currentInstru,
              idDemandeForm: form.ID,
              isEditable: isEditable,
			  isHistoric:(this.historique && this.unlock)
            }; 
        
          dialogRef = this.dialog.open(FormDialogFormulaireWithSFComponent,{
            data: datasF,
            panelClass: ['animate__animated','animate__slideInDown'],
            height:"90vh",
            width:"80vw"
          });
        }

        if(dialogRef){
          dialogRef.afterClosed().pipe(first()).subscribe(result => {
            if(this.tiers.type === "MAM")
            {
              this.stateService.updateStateQuickmenu({state :"MAMPage"});
            }
            else
              this.stateService.updateStateQuickmenu({state :"AssistmatPage"});
            if(result){
              this.utilities.log(result);
            }
            
            this.isLoadInstruction=false;
            this.lastAgrement = undefined;
            this.lastFormation = undefined;
    
                this.isLoadDossier=false;
                this.reloadDossier();
    
          });
        }

    }

    printFormulaire(form:any) {
        this.appService.printFormulaire(form.ID, false,true).subscribe((res) => {
          if(res.result && res.result.length > 0)
            window.open(res.result[0].value.url);
          else
            of(window.confirm("Pas de donnée disponible"));
        });
    }

    cancelInstruction() {
        this.currentInstru = this.selectedInstruc;
        const confDialogRef = this.dialogService.open(ConfirmComponent, {
          data : {
            libelle : 'Etes-vous sur de vouloir annuler cette procédure ?'
          }
        });
        confDialogRef.afterClosed().subscribe(res => {
            console.log('res:',res);
          if(res === 'true'){
            this.currentInstru = this.selectedInstruc;
            this.appService.cancelInstruction(this.currentInstru.ID).subscribe((res) => {
              this.isLoadInstruction=false;
                  this.tabInstructionLoad();
				   this.loadTabs.emit();
				  
            });
          }
        });
        
    }

    updateInstructeurToUserDossier(){
        const confDialogRef = this.dialogService.open(TransmettreDialogComponent);
        confDialogRef.afterClosed().subscribe(res => {
            if(res && res.validate){
                this.updInstruc = true;
                this.currentInstru = this.selectedInstruc;
                this.currentInstru.instructeurid = this.dossier.tiers.ID;
                this.currentInstru.comment = res.comment;
                this.appService.setInstruction(this.currentInstru).subscribe((res) => {
                    this.updInstruc = false;
                    this.isLoadInstruction=false;
                    this.tabInstructionLoad();
                
                });
            }
        });
    }

    updateInstructeurToUser(){
        this.currentInstru = this.selectedInstruc;
        let pastInstruc = this.currentInstru.instructeur;
        let toConfirm = true;
        Object.keys(this.user.droits).forEach((droit) => {
          if(droit === "AUCUNE_CONFIRMATION" || droit === "AUCUNE_CONFIRMATION_UTILISATEUR"){
            toConfirm = false;
          }
        })
        if(toConfirm){
          const confDialogRef = this.dialogService.open(ConfirmComponent, {
            data : {
              libelle : 'Etes-vous sur de vouloir changer de personne en charge ?'
            }
          });
          confDialogRef.afterClosed().subscribe(res => {
            if(res === "true"){
              this.updInstruc = true;
              this.currentInstru.instructeurid = this.user.id;
              this.appService.setInstruction(this.currentInstru).subscribe((res) => {
                this.updInstruc = false;
                 this.isLoadInstruction=false;
                  this.tabInstructionLoad();
              });
            }
            else
              this.currentInstru.selectedTier = pastInstruc;
          });
        }
        else{
          this.updInstruc = true;
          this.currentInstru.instructeurid = this.user.id;
          this.appService.setInstruction(this.currentInstru).subscribe((res) => {
            this.updInstruc = false;
             this.isLoadInstruction=false;
              this.tabInstructionLoad();
          });
        }
    }

    triggerAutocompSelectionList(search: any) {
        this.debounce.next(search);
    }

    updateInstructeurInstruction(instructeur: any){
      this.currentInstru = this.selectedInstruc;
      
          let pastInstruc = this.currentInstru.instructeur;
          let toConfirm = true;
          Object.keys(this.user.droits).forEach((droit) => {
            if(droit === "AUCUNE_CONFIRMATION" || droit === "AUCUNE_CONFIRMATION_UTILISATEUR"){
              toConfirm = false;
            }
          })
          if(toConfirm){
            const confDialogRef = this.dialogService.open(ConfirmComponent, {
              data : {
                libelle : 'Etes-vous sur de vouloir changer la personne en charge ?'
              }
            });
            confDialogRef.afterClosed().subscribe(res => {
              if(res === "true"){
                this.updInstruc = true;
                this.currentInstru.instructeurid = instructeur.ID;
                this.appService.setInstruction(this.currentInstru).subscribe((res) => {
                  this.updInstruc = false;
                   this.isLoadInstruction=false;
                    this.tabInstructionLoad();
          
                });
              }
              else
                this.currentInstru.selectedTier = pastInstruc;
            });
          }
          else{
            this.updInstruc = true;
            this.currentInstru.instructeurid = instructeur.ID;
            this.appService.setInstruction(this.currentInstru).subscribe((res) => {
              this.updInstruc = false;
               this.isLoadInstruction=false;
                this.tabInstructionLoad();
      
            });
          }
      }

    openHistorique(instruction:any) {
		console.log('openHistorique',instruction,this.dossier);
		this.dialogService.open(InstructionHistoriqueDialog, {
			data: {
				instruction: instruction,
				dossier: this.dossier
			},
			
		/*	height: "50vh",*/
            width: "30%"
			}
		);
	}

    changeInstructionEtape(){
        const confDialogRef = this.dialogService.open(EtapeinstructionComponent, {
          data : {
            instruction : this.selectedInstruc,
            iddossier : this.dossier.ID
          },
		  width: "30%"
        });
        confDialogRef.afterClosed().subscribe(res => {
          if(res.etape!=undefined && res.instructeur!=undefined
			&& res.etape && res.instructeur
		  ){
            this.currentInstru.transitionid = res.etape.key;
            this.currentInstru.instructeurid = res.instructeur.ID;
            this.currentInstru.comment = res.comment ? res.comment : '';
            this.appService.setTransitionInstruction(this.currentInstru).subscribe((res) => {
              if (res.result.ID) {
                  this.cachedInstruc = res.result.ID;
                  //  this.afterTransitionInstruction = res.result;
              }
              this.updInstruc = false;
              this.isLoadInstruction=false;
              this.tabInstructionLoad();
              this.loadTabs.emit();
            });
          }
          this.changeDetectorRef.detectChanges();
        });
    }

    stateDoc(statut: any){
        switch(String(statut)){
          case '0':
            return 'Indéfini';
          case '1':
            return 'Refusé';
          case '2':
            return 'Validé';
        }
    }

        
    changeInstructionEnfant(instruction: any, type:any){
      console.log("DossierPageInstructionsComponent changeInstructionEnfant begin",instruction);
      this.updInstruc = false;
      this.updDossier = true;
      let instru = {...instruction};
      if(!instru.demande.type)
          instru.demande.type = {ID : ''};

      this.selectedInstruc = instru;
      this.selectedInstruc.expandForm = true;
      this.selectedInstruc.expandCour = true;
      this.selectedInstruc.expandRDV = true;
      this.selectedInstruc.expandDoc = true;
      this.cachedInstruc = instru.ID;
      
      if (this.tabGroup!==undefined)
          this.tabGroup.tabs._results.forEach((tab) => {
              if(tab.isActive)
                  this.currentTab = tab.textLabel;
          });
      this.currentInstru = this.selectedInstruc;
      //this.getDroit(this.selectedInstruc);
      let _options={
            
          }
      instruction.commentaire=null;
      this.appService.instruction_droit(this.selectedInstruc.ID,_options).subscribe((res: any) => {
        
     
         this.droits=res.result;
         
         if (this.droits.commentaire!=undefined
         && this.droits.commentaire
          && this.droits.commentaire.length>0
         ) 
       this.selectedInstruc.commentaire=this.droits.commentaire
     
         
         console.log(' get droit',this.selectedInstruc,this.droits);
         //this.changeDetectorRef.detectChanges();
        
  
  
      this.selectedInstruc.debutdate = new Date(instru.debutdate);
      
      let droitform:any[]=[];
      if (this.droits.droits!=undefined 
      && this.droits.droits.form!=undefined)
          droitform=this.droits.droits.form
      let _opts:any={notValueType:[0,2,3,4,5,6,7],noType:[6,7]}
      this.appService.getFormulairesForDemande(instruction.demande.ID,false,_opts)
          .pipe(first())
          .subscribe((forms) => 
      {
    console.log("load formulaire demande1",instruction.demande.ID,forms,droitform,this.droits);
    let tempForms = [];
          let rdvForms = [];
          forms.result.forEach((form) => {
          
              let added:boolean=true;
              form.editable=true;
              console.log("DossierPageInstructionsComponent changeInstructionEnfant",form,this.userRigthsElement) 

              if (
                  form.form   !=undefined
                  &&  form.form.key !=undefined 
                  && form.form.key
                  && droitform[form.form.key]!=undefined
                  && droitform[form.form.key].r!=undefined	
              ) {
            //	console.log("formulaireService dorit r",droitform[f.form.key],f)
                  if (!droitform[form.form.key].r)
                      added=false;
              }
              
              if (
                  form.form   !=undefined
                  &&  form.form.key !=undefined 
                  && form.form.key
                  && droitform[form.form.key]!=undefined
                  && droitform[form.form.key].w!=undefined	
              ) {
                  form.editable=droitform[form.form.key].w;
              } 
              
              let rg:any={
        r:true,
        w:true
      };
              if ( form.form   !=undefined
                  &&  form.form.key !=undefined 
                  && form.form.key
        && this.userRigthsElement["formulaire"]!=undefined
              && this.userRigthsElement["formulaire"][form.form.key]!=undefined
              )
              rg=this.userRigthsElement["formulaire"][form.form.key];
              form.right=rg;
                             
              if (added) {
                  if(form.form && (form.form.type === 0 || form.form.type === 3 ||form.form.type === 5))
                      tempForms.push(form);
                  else if(form.form && form.form.type === 1)
                      rdvForms.push(form);
              }
          });
          console.log("DossierPageInstructionsComponent changeInstructionEnfant",tempForms);
          instru.selectedForms = tempForms;
          instru.selectedRDV = rdvForms;

          instru.selectedRDV.forEach(element => {
              if(element.form && element.form.fields && element.form.fields.length > 0){
                  element.form.fields.forEach((field) => {
                      if(field.field && (field.field.key === "RENDEZVOUS_DATE" || field.field.key === "DATEWITHTIME")) {
                          element.timeRDV = field.value;
                      }
                  });
              }
          });
          instru.selectedRDV = _.orderBy(instru.selectedRDV,"timeRDV",["desc"]);
          this.changeDetectorRef.detectChanges();
      });
      
      let droitdoc:any[]=[];
  if (this.droits.droits!=undefined 
          && this.droits.droits.document!=undefined)
              droitdoc=this.droits.droits.document
      
      this.appService.getListDocumentsForInstruction(instruction.ID).pipe(first()).subscribe((res) => {
          let ds:any=[];
          res.result.forEach((d) => {
              let added:boolean=true;
              d.editable=true;
              // console.log("getListDocumentsForInstruction dorit before",droitdoc,d,
              // d.document.type,d.document.type.key, droitdoc[d.document.type.key])
              if (
                  d.document   !=undefined
                  && d.document.type   !=undefined
                  &&  d.document.type.key !=undefined 
                  && d.document.type.key
                  && droitdoc[d.document.type.key]!=undefined
                  && droitdoc[d.document.type.key].r!=undefined	
                  ) 
              {
          //	console.log("getListDocumentsForInstruction dorit r",droitdoc[d.document.type.key],d) 
                  if (!droitdoc[d.document.type.key].r)
                  added=false;
              }
                  
              if (
                  d.document   !=undefined
                  && d.document.type   !=undefined
                  &&  d.document.type.key !=undefined 
                  && d.document.type.key
                  && droitdoc[d.document.type.key]!=undefined
                  && droitdoc[d.document.type.key].w!=undefined
                  ) 
              {
                  d.editable=droitdoc[d.document.type.key].w;
                  //  console.log("getListDocumentsForInstruction dorit w",droitdoc[d.document.type.key],d)   
              }
               let rg:any={
        r:true,
        w:true
      };
              if (  d.document   !=undefined
                  && d.document.type   !=undefined
                  &&  d.document.type.key !=undefined 
                  && d.document.type.key
        && this.userRigthsElement["document"]!=undefined
              && this.userRigthsElement["document"][d.document.type.key]!=undefined
              )
              rg=this.userRigthsElement["document"][d.document.type.key];
              d.right=rg;
                  
              if (added)
                  ds.push(d);
                  
          });
          instru.documents = ds;
          //instru.documents = res.result;
          console.log("DossierPageInstructionsComponent changeInstructionEnfant document ",ds);
          if(instru.documents && instru.documents.length > 0){
              instru.documents.forEach((doc) => {
              let alreadyIn = false;
              this.allDocumentsDossier.forEach((docSave) => {
                  if(docSave.document && docSave.document.type && docSave.document.type.key === doc.document.type.key)
                  alreadyIn = true;
              });
              if(!alreadyIn && doc.ID === 0)
                  this.allDocumentsDossier.push(doc);
              })
          }
          this.changeDetectorRef.detectChanges();
      });
      if(instruction.type && instruction.type.professions && instruction.type.professions.length > 0){
          let professions = [];
          instruction.type.professions.forEach(element => {
              professions.push(element.key);
          });
          let onlyzone:boolean=false;
          if (instruction.type.zone!=undefined)
             onlyzone=instruction.type.zone;
          let currentID:number=undefined;
              
          if (instruction.instructeur!=undefined &&  instruction.instructeur.ID!=undefined)
             currentID=  instruction.instructeur.ID;   
             
          this.appService.getUsersByProfressions(professions,this.dossier.ID,null,onlyzone,currentID).subscribe((res) => {
              instru.possibleTiers = res.result;
              
              let grp:any={};
              instru.possibleGroupTiers=[];
              instru.possibleTiers.forEach((r: any) => {
        if (grp[""+r.sameZone]==undefined) {
              grp[""+r.sameZone]={
                 label:r.tiersZone,
                 tiers:[],
                 ordre:r.sameZone
               };
        }
        grp[""+r.sameZone].tiers.push(r);
      });	
      let grps:any[]=[];
      let keys:any[]=Object.keys(grp).sort((a,b) => ( a > b) ? -1:1);
      console.log("group getUsersByProfressions ajax",keys,grp)
      for (let i = 0; i <keys.length; i++) {
        grps.push(grp[keys[i]]);
      }	
      //grp.reverse();
      instru.possibleGroupTiers=grps;//.sort((a,b) => ( a.ordre > b.ordre) ? 1:-1);
      console.log("group getUsersByProfressions",grps);
      
              instru.possibleTiers.push(this.dossier.tiers)
              instru.possibleTiers.forEach(element => {
                  if(instru.instructeur.ID === element.ID)
                      instru.selectedTier = element;
              });
              this.changeDetectorRef.detectChanges();
          });
  
          this.debounce.pipe(
              debounceTime(1000)
          ).subscribe(search => {
              if(search.length > 0){
        
        
                  this.appService.getUsersByProfressions(professions,this.dossier.ID, search,onlyzone,currentID).subscribe((result) => {
                      instru.possibleTiers = result.result;
                      
                      let grp:any={};
                      instru.possibleGroupTiers= [];
                  instru.possibleTiers.forEach((r: any) => {
            if (grp[""+r.sameZone]==undefined) {
                  grp[""+r.sameZone]={
                     label:r.tiersZone,
                     tiers:[],
                        ordre:r.sameZone
                   };
            }
            grp[""+r.sameZone].tiers.push(r);
          });	
          let grps:any[]=[];
          let keys:any[]=Object.keys(grp).sort((a,b) => ( a > b) ? -1:1);
          console.log("group getUsersByProfressions ajax",keys,grp)
          for (let i = 0; i <keys.length; i++) {
            grps.push(grp[keys[i]]);
          }	
          //grp.reverse();
          instru.possibleGroupTiers=grps;//.sort((a,b) => ( a.ordre > b.ordre) ? 1:-1);
          console.log("group getUsersByProfressions ajax",grps);
                      
                      this.changeDetectorRef.detectChanges();
                  });
              }

          });
    
    
    
      }
      this.appService.getListCourrier(instru.demande).pipe(first()).subscribe((res) => {
    
          let droitcourier:any[]=[];
          if (this.droits.droits!=undefined && this.droits.droits.courrier!=undefined)
              droitcourier=this.droits.droits.courrier	
          let cs:any=[];
          res.result.forEach((c) => {
              let added:boolean=true;
              c.editable=true;
              console.log("getListCourrier droit before",droitcourier,c,
              c.courrier,c.courrier.key, droitcourier[c.courrier.key])
              
              if (
                  c.courrier   !=undefined
                  && c.courrier.key !=undefined 
                  && droitcourier[c.courrier.key]!=undefined
                  && droitcourier[c.courrier.key].r!=undefined	
              ) {
                  console.log("getListCourrier droit r",droitcourier[c.courrier.key],c) 
                  if (!droitcourier[c.courrier.key].r)
                      added=false;
              }
                  
              if (
                  c.courrier   !=undefined
                  && c.courrier.key !=undefined 
                  && droitcourier[c.courrier.key]!=undefined
                  && droitcourier[c.courrier.key].w!=undefined	
              ) {
                  c.editable=droitcourier[c.courrier.key].w;
                  console.log("getListCourrier droit w",droitcourier[c.courrier.key],c)   
              }
               
              let rg:any={
        r:true,
        w:true
      };
              if (  c.courrier   !=undefined
                  && c.courrier.key !=undefined 
        && this.userRigthsElement["courrier"]!=undefined
              && this.userRigthsElement["courrier"][c.courrier.key]!=undefined
              )
              rg=this.userRigthsElement["courrier"][c.courrier.key];
              c.right=rg; 
                  
              if (added)
                  cs.push(c);
          });
    
          instru.courriers =cs;	
        //instru.courriers = res.result;
     console.log("DossierPageInstructionsComponent changeInstructionEnfant courrier",cs);
          this.changeDetectorRef.detectChanges();
      });
      instru.droit = this.dossier.etat.ID ? this.dossier.etat.ID : '';
      this.stateService.demandeType.subscribe((demandeTypes) => {
          if (demandeTypes!==undefined && demandeTypes!=='') {
              demandeTypes.forEach((type) => {
                  if(instruction.demande && instruction.demande.type 
                      && type.ID === instruction.demande.type.ID)
                  {
                      type.forms.forEach((form) => {
                          if(form.type === 1)
                          this.typeFormsRDV.push(form);
                      });
                  }
              });
          }
      });
      
      if(this.userDroits && this.userDroits.length > 0){
          Object.keys(this.userDroits[0]).forEach((userDroitIndex) => {
              if(this.router.url.toUpperCase().indexOf(userDroitIndex) !== -1){
                  this.updDossier = this.userDroits[0][userDroitIndex].w; 
                  this.updInstruc = !this.userDroits[0][userDroitIndex].w; 
              }
      });
      }
      if(instru && instru.instructeur.ID !== undefined && instru.instructeur.ID !== this.user.id){
          instru.disabled = true;
      }
      else if(instru && instru.instructeur.ID !== undefined && instru.instructeur.ID === this.user.id){
          instru.disabled = false;
      }
      
      
      if(this.currentInstru && this.currentInstru.disabled){
          this.updInstruc = true;
          this.updDossier = false;
          this.updSigna = false;
      }
      else if(this.currentInstru && !this.currentInstru.disabled){
          this.updSigna = true; 
          this.updInstruc = false;
          this.updDossier = true;
      }
      
      this.signataire = "";
      if(instru.signataire && instru.signataire.ID !== undefined){
          this.signataire = instru.signataire.nom + " " 
              + instru.signataire.prenom + ' le '+moment(instru.signaturedate).format("DD MMMM YYYY");
      }
  });
      console.log("changeInstructionEnfant",this.updDossier, this.updInstruc);
}

   
tabInstructionLoad() {
	this.loadingInstructionList=false;
	if (!this.isLoadInstruction) {
    console.log("DossierPageInstructionsComponent getDossierInsctructionList")
		 this.loadingInstructionList=true;
      var searchI = [this.typeInstruction];
      var etatInstruSearch = this.historique != undefined && this.historique? "historique": "active";
      searchI.push(etatInstruSearch);
      let _options:any={
        searchI: searchI
      };
	  this.listSubscribe.push(
	      this.appService.getDossierInsctructionList(this.dossier.ID,_options).pipe(first())
	      	.subscribe(instruction => {
	          if(!this.dossier)
	            this.dossier = {};
	          this.dossier.instructions=instruction.result.instructions;
	 		      this.dossier.demandes=instruction.result.demandes;
			      this.dossier.documents=instruction.result.documents;
			   
			    let container = [];     
					 if(this.dossier.documents === Object(this.dossier.documents)){
			      container = [this.dossier.documents];
					
			    }
			    if(container.length > 0){
			      //TODO GROUPE DOCUMENT PAR DATE, SOUS TYPE LES DOCUMENTS
			      container.forEach((inst)=> {
			        let group = [];
			        Object.keys(inst).forEach((demande) => {
			          inst[demande].forEach((doc) => {
			            doc.demandeid = demande;
	                let inGroupFirstLevel = false;
	                let inGroupSecondLevel = false;
			            _.forEach(group , ((elem) => {
			              if(elem.key === doc.document.type.key){
	                    inGroupFirstLevel = true;
	                    _.forEach(elem.children, ((underElem) => {
	                      if(underElem.key && underElem.key === doc.parameter){
	                        inGroupSecondLevel = true;
	                        underElem.children.push({
	                          name : this.datePipe.transform(doc.creationdate, 'dd-MM-yyyy') + " - "+ ' ('+this.stateDoc(doc.status)+') ('+(doc.archive ? 'Archivé' : 'Actif')+')',
	                          value: doc
	                        })
	                      }
	                    }));
	                    if(!inGroupSecondLevel){
	                      if(doc.parameter && doc.parameter != ""){
	                        elem.children.push({
	                          key : doc.parameter,
	                          name: doc.parameter,
	                          children : [{
	                            name : doc.libelle + " - " + this.datePipe.transform(doc.creationdate, 'dd-MM-yyyy') + " - " + ' ('+this.stateDoc(doc.status)+') ('+(doc.archive ? 'Archivé' : 'Actif')+')',
	                            value: doc
	                          }]
	                        });
	                      }
	                      else{
	                        elem.children.push({
	                          name: doc.libelle + " - " + this.datePipe.transform(doc.creationdate, 'dd-MM-yyyy') + " - " + ' ('+this.stateDoc(doc.status)+') ('+(doc.archive ? 'Archivé' : 'Actif')+')',
	                          value: doc
	                        });
	                      }
	                    }
			                return false;
			              }
			              else{
			                inGroupFirstLevel = false;
			              }
			            }));
			            if(inGroupFirstLevel === false){
	                  let element  = {
	                    key : doc.document.type.key,
			                name : doc.document.type.libelle,
			                children : []
	                  }
	                  if(doc.parameter && doc.parameter != ""){
	                    element.children.push({
	                      key : doc.parameter,
	                      name: doc.parameter,
	                      children : [{
	                        name : doc.libelle + " - " + this.datePipe.transform(doc.creationdate, 'dd-MM-yyyy') + " - " + ' ('+this.stateDoc(doc.status)+') ('+(doc.archive ? 'Archivé' : 'Actif')+')',
	                        value: doc
	                      }]
	                    });
	                  }
	                  else{
	                    element.children.push({
	                      name: doc.libelle + " - " + this.datePipe.transform(doc.creationdate, 'dd-MM-yyyy') + " - " + ' ('+this.stateDoc(doc.status)+') ('+(doc.archive ? 'Archivé' : 'Actif')+')',
	                      value: doc
	                    })
	                  }
			              group.push(element);
			            }
			          });
			        });
			        
			      });
			    }
				  this.listInstructions=[];
	        if(this.dossier.instructions && this.dossier.instructions.length > 0){
	            this.dossier.instructions.forEach((instru) => {
						
	              let rights:any= {
	                  r:true,
	                  w:true
	                };
	                if (instru.type!=undefined
	                && instru.type.key!=undefined
	                && this.userRigths[instru.type.key]) {
	                  
	                  let rg:any=this.userRigths[instru.type.key];
	                  if (rg.r!=undefined)
	                    rights.r=rg.r;
	                    
	                  if (rg.w!=undefined)
	                    rights.w=rg.w;
	                }
	                instru.right=rights;
	              
	              if(instru.demande && instru.demande.forms && instru.demande.forms.length > 0){
	                instru.demande.forms.forEach((form) => {
	                  this.listAgrement.forEach((agrement) => {
	                    if(form.form && agrement.form && form.form.ID === agrement.form.ID){
	                      agrement.instruction = instru;
	                    }
	                  });
	                  if(this.lastAgrement && this.lastAgrement.form && form.form.ID === this.lastAgrement.form.ID)
	                    this.lastAgrement.instruction = instru;
	                });
	              }
	              if(this.listInstructions.length === 0 && !this.cachedInstruc)
	                this.cachedInstruc = instru.ID
	            
	              this.listInstructions.push(instru);
	            
	          });
	
	
	        
	        if (this.stateService.loadCreated != false) {
	          let createdInstruc = this.stateService.instrucSelected;
	          this.changeInstructionEnfant(createdInstruc, this.typeInstruction);
	          this.stateService.loadCreated = false;
	        }
	
	      }
	      let changeEmiiter= {
	        historique: this.historique,
	        instructions: this.listInstructions
	      };
	      this.change.emit(changeEmiiter);
	
	      this.loadingInstructionList=false;
	      
	      if(this.dossier.instructions){
	        const instructionToOpen = this.dossier.instructions.find(ins=>ins.ID === this.cachedInstruc)
	        if(instructionToOpen)
	          this.changeInstructionEnfant(instructionToOpen, this.typeInstruction);
	      }
	      
	      this.isLoadInstruction=true;
	       
	     	})
		);
     	 this.changeDetectorRef.detectChanges();
	}
	
  }
  
  /*generateDataFromDossier(dossier) {
    this.dossier = null;
    this.dossier = dossier;
    this.dossier.findate = new Date(this.dossier.findate);

    let suivis = [];
    if(dossier.suivis && dossier.suivis.length > 0){
        dossier.suivis.forEach((suivi) => {
        suivis.push({
            id: suivi.ID,
            name: suivi.label + " (" + suivi.type.label + ")",
            value: "",
            type: suivi.key,
            creationDate: moment(suivi.creationdate).format("DD MMMM YYYY")
        });
        });
    }
    this.tiers = dossier.tiers;
    this.appService.tierAccess(this.tiers.ID)
        .pipe(first())
        .subscribe((data) => {
        
        this.tierAccess = data.result;
        });
    this.donneesEquip = _.values(_.groupBy(dossier.tiers.donnees, 'groupe.key'));
    if(this.donneesEquip.length > 0){
        this.donneesEquip.forEach((group, index) => {
        this.donneesEquip[index] = group.filter((element) => {
            if(element.etat && element.origin && element.origin.texte && element.origin.texte !== "")
            return element;
            else if(element.etat && element.origin && element.origin.length > 0)
            return element;
        });
        });
        this.donneesEquip = this.donneesEquip.filter((group) => {
        return group.length > 0;
        })
    }

    this.donnees = _.groupBy(dossier.tiers.donnees, 'groupe.key');
    let syntheseGroup = null;
    this.donneesSynth = null;
    Object.keys(this.donnees).forEach((index) => {
        if(index === "SYNTHESE"){
            syntheseGroup = [...this.donnees[index]];
        }
    });
    if(syntheseGroup){
        let filteredSynthGroup:any;
        syntheseGroup.forEach((synth, index) => {
        synth.createdate = moment(synth.createdate).format("DD/MM/YYYY");
        if(filteredSynthGroup === undefined)
            filteredSynthGroup = [];
        if(synth.origin && synth.origin.length !== 0){
            filteredSynthGroup.push(synth);
            this.hasSynth = true;
        }
        })
        filteredSynthGroup = _.groupBy(filteredSynthGroup, 'createdate');
        Object.keys(filteredSynthGroup).forEach(index => {
        if(filteredSynthGroup[index].length > 1)
        filteredSynthGroup[index] = _.values(_.groupBy(filteredSynthGroup[index], 'placement'));
        else
        filteredSynthGroup[index] = [filteredSynthGroup[index]];
        })
        this.donneesSynth = Object.entries(filteredSynthGroup).sort((a,b) => moment(b[0], "DD/MM/YYYY", true).valueOf() - moment(a[0], "DD/MM/YYYY", true).valueOf());
    }
    let group = [];
    if(this.donneesSynth){
        Object.keys(this.donneesSynth).forEach((groupDate) => {
        this.donneesSynth[groupDate][1].forEach((groupSynth) => {
            let inGroupFirstLevel = false;
            let inGroupSecondLevel = false;
            _.forEach(group , ((elem) => {
            if(elem.key === this.donneesSynth[groupDate][0]){
                inGroupFirstLevel = true;
                groupSynth.forEach((synth) => {
                _.forEach(elem.children, ((underElem) => {
                    if(underElem.key && underElem.key === synth.placement){
                    inGroupSecondLevel = true;
                    underElem.children.push({
                        name : (elem.label ? elem.label + " : " : "")  + (synth.origin && synth.origin.texte ? synth.origin.texte : "")
                    })
                    }
                }));
                if(!inGroupSecondLevel){
                    if(synth.placement && synth.placement != ""){
                    let elementToPush = {
                        key : synth.placement,
                        name: synth.placement ? synth.placement : "Sans Groupe",
                        children : [{
                        name : (synth.label ? synth.label + " : " : "") + (synth.origin && synth.origin.texte ? synth.origin.texte : "")
                        }]
                    }
                    elem.children.push(elementToPush);
                    }
                    else{
                    elem.children.push({
                        name : (synth.label ? synth.label + " : " : "") + (synth.origin && synth.origin.texte ? synth.origin.texte : "")
                    });
                    }
                }
                });
                
                return false;
            }
            else{
                inGroupFirstLevel = false;
            }
            }));
            if(inGroupFirstLevel === false){
            let element  = {
                key : this.donneesSynth[groupDate][0],
                name : this.donneesSynth[groupDate][0],
                children : []
            }
            groupSynth.forEach((synth) => {
                _.forEach(element.children, ((underElem) => {
                if(underElem.key && (underElem.key === synth.placement)){
                    inGroupSecondLevel = true;
                    underElem.children.push({
                    name : (synth.label ? synth.label + " : " : "")  + (synth.origin && synth.origin.texte ? synth.origin.texte : "")
                    })
                }
                }));
                if(!inGroupSecondLevel){
                if(synth.placement && synth.placement != ""){
                    let elementToPush = {
                    key : synth.placement,
                    name: synth.placement ? synth.placement : "Sans Groupe",
                    children : [{
                        name : (synth.label ? synth.label + " : " : "") + (synth.origin && synth.origin.texte ? synth.origin.texte : "")
                    }]
                    }
                    element.children.push(elementToPush);
                }
                else{
                    element.children.push({
                    name : (synth.label ? synth.label + " : " : "") + (synth.origin && synth.origin.texte ? synth.origin.texte : "")
                    })
                }
                }
            });
            group.push(element);
            }
        });
        });

    }

    this.etat = dossier.etat;
    console.log(this.etat,"currnet dossier etat",dossier);
    if(dossier.tiers && dossier.tiers.type === "MAM")
        this.stateService.updateStateQuickmenu({state :"MAMPage"});
    else
        this.stateService.updateStateQuickmenu({state :"AssistmatPage"});
    if(dossier.tiers && dossier.tiers.type === "CCPD")
        this.selectedTab = 2;
    this.nom =(dossier.tiers.NOM ? dossier.tiers.NOM : '') + " " + (dossier.tiers.PRENOM ? dossier.tiers.PRENOM : '');
    this.reference = dossier.reference ? dossier.reference : '';
    let dateInBD = dossier.findate
    this.AgreeJusquAuDate = moment(dateInBD).isValid() ? dossier.findate : null;
    
        let dateDEbutInBD = dossier.debutdate
    this.AgreeDuAuDate = moment(dateDEbutInBD).isValid() ? dossier.debutdate : null;
    
    this.loading = false;
    let container = [];
    this.selectedInstruc = this.clearSelectInstruction();
    
    if(this.dossier.documents === Object(this.dossier.documents)){
        container = [this.dossier.documents];
    }
    if(container.length > 0){
        //TODO GROUPE DOCUMENT PAR DATE, SOUS TYPE LES DOCUMENTS
        container.forEach((inst)=> {
        let group = [];
        });
    }
    if(this.dossier.instructions && this.dossier.instructions.length > 0){
        this.listInstructions = [];
        let activeInstru = [];
        this.dossier.instructions.forEach((instru) => {
    if(instru.demande && instru.demande.forms && instru.demande.forms.length > 0){
      instru.demande.forms.forEach((form) => {
      this.listAgrement.forEach((agrement) => {
        if(form.form && agrement.form && form.form.ID === agrement.form.ID){
        agrement.instruction = instru;
        }
      });
      if(this.lastAgrement && this.lastAgrement.form && form.form.ID === this.lastAgrement.form.ID)
        this.lastAgrement.instruction = instru;
      });
    }
    if(!instru.etape.historique){
      if(activeInstru.length === 0 && !this.cachedInstruc)
        this.cachedInstruc = instru.ID
        activeInstru.push(instru);
    }
        });
        this.listInstructions = activeInstru;

if (this.stateService.loadCreated != false) {
  let createdInstruc = this.stateService.instrucSelected;
  let tempInstruc = 0;
  let tempInstrucSuivi = 0;
  let tempInstrucHisto = 0;
  if(!createdInstruc.etape.historique){
    if(createdInstruc.type && createdInstruc.type.typeID === 1)
      tempInstrucSuivi = createdInstruc;
    else
    tempInstruc = createdInstruc;
  }else{
    tempInstrucHisto = createdInstruc;
  }
  
  if (tempInstruc) {
    this.changeInstructionEnfant(createdInstruc, 'Instruction');
  } 
}

}
    let removeCache = null;
        if(dossier.instructions)
        dossier.instructions.forEach((instruc) => {
            if(instruc.ID === this.cachedInstruc){
                this.changeInstructionEnfant(instruc, 'Instruction');
                if(instruc.etape && instruc.etape.historique){
                this.cachedInstruc = null;
                ;
                }
            }
        })
        
    console.log("dates",this.AgreeDuAuDate,this.AgreeJusquAuDate) ;  
   
    this.changeDetectorRef.detectChanges();
}*/
  
   getDroit(instruction: any) {
		let _options={
			
		}
		instruction.commentaire=null;
		this.appService.instruction_droit(instruction.ID,_options).subscribe((res: any) => {
		   
		   
           this.droits=res.result;
           
           if (this.droits.commentaire!=undefined
           && this.droits.commentaire
            && this.droits.commentaire.length>0
           ) 
			   instruction.commentaire=this.droits.commentaire
		   
           
           console.log(' get droit',instruction,this.droits);
            this.changeDetectorRef.detectChanges();
          });
	}
	
	getTitleDeverruiller(form:any) {
		
		let alt:string='Déverrouiller le formulaire';
		if (form.verrouilleur!=undefined && form.verrouilleur) {
			
			let names:string[]=[];
			if (form.verrouilleur.nom!=undefined) 
				names.push(form.verrouilleur.nom)
			if (form.verrouilleur.prenom!=undefined) 
				names.push(form.verrouilleur.prenom)
			if 	(names.length>0)
				alt+="\n"+names.join(" ");		
		}
		return alt;	
	}
 
}